import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MoradorComponent } from "./morador.component";
import { CadastroMoradorComponent } from "./cadastro.component";

import { NgxMaskModule } from 'ngx-mask'
import { DataTablesModule } from 'angular-datatables';

@NgModule({
  declarations: [
    MoradorComponent,
    CadastroMoradorComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [
    MoradorComponent,
    CadastroMoradorComponent,
  ]
})

export class MoradorModule {}
